import { useRef, useState } from "react";
import axiosInstance from "../../utils/axiosInstance";
import DynamicDataTable from "../../components/DynamicDataTable";
import { StatusEnum, YesNoEnum } from "../../assets/common";
import { Toast } from "primereact/toast";
import CustomerDialogWrapper from "../../components/CustomerDialogWrapper";
import { useLoading } from "../../components/Loading/LoadingProvider";

const CustomerList = () => {
    const toast = useRef(null);
    const { setLoading } = useLoading();


    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);

    const columns = [
        {
            field: 'actions',
            header: 'Güncelle',
            body: (rowData) => (
                <div className="flex justify-center items-center">
                    <CustomerDialogWrapper
                        buttonLabel=""
                        buttonIcon="pi pi-user-edit"
                        buttonClassName="p-button-rounded p-button-text p-button-warning"
                        customerData={rowData}
                        onCustomerSaved={() => refreshData()}
                    />
                </div>
            ),
        },
        {
            field: 'name',
            header: 'Müşteri',
            sortable: true,
            body: (rowData) => `${rowData.name || ''} ${rowData.surname || ''}`
        },
        {
            field: 'identityNumber',
            header: 'TC Kimlik No',
            sortable: true,
        },
        {
            field: 'phoneNumber1',
            header: 'Telefon Numarası - 1',
            sortable: true,
        },
        {
            field: 'phoneNumber2',
            header: 'Telefon Numarası - 2',
            sortable: true,
        },
        {
            field: 'address',
            header: 'Ev Adresi',
            //sortable: true,
            body: (rowData) => {
                const parts = [
                    rowData.detailOfAddress,
                    rowData.districtOfAddress,
                    rowData.countryOfAddress,
                ].filter(Boolean);
                return parts.join(' / ');
            }
        },
        {
            field: 'workAddress',
            header: 'İş Adresi',
            //sortable: true,
            body: (rowData) => {
                const parts = [
                    rowData?.detailOfWorkAddress,
                    rowData?.districtOfWorkAddress,
                    rowData?.countryOfWorkAddress,
                ].filter(Boolean);
                return parts.join(' / ');
            }
        },
        {
            field: 'birthday',
            header: 'Doğum Tarihi',
            sortable: true,
            body: (rowData) =>
                rowData?.birthday ? new Date(rowData?.birthday).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : ''
        },
        {
            field: 'birthLocation',
            header: 'Doğum Yeri',
            //sortable: true,
            body: (rowData) => {
                const parts = [
                    rowData?.countryOfBirth,
                    rowData?.districtOfBirth
                ].filter(Boolean);
                return parts.join(' / ');
            }
        },
        {
            field: 'isBusinessCustomer',
            header: 'Ticari Müşteri',
            sortable: true,
            body: (rowData) => rowData?.isBusinessCustomer ? rowData?.isBusinessCustomer.value : '',
        },
        {
            field: 'vkn',
            header: 'VKN',
            sortable: true,
        },
        {
            field: 'companyName',
            header: 'Firma Adı',
            sortable: true,
        },
        {
            field: 'status',
            header: 'Durum',
            sortable: true,
            body: (rowData) => rowData.status ? rowData.status.value : '',
        },
        {
            field: 'kvkk',
            header: 'KVKK',
            sortable: true,
            body: (rowData) => rowData.kvkk ? rowData.kvkk.value : '',
        },
    ];

    const filterFields = [
        {
            field: 'name',
            label: 'Ad',
            type: 'text',
        },
        {
            field: 'surname',
            label: 'Soyad',
            type: 'text',
        },
        {
            field: 'identityNumber',
            label: 'TC Kimlik No',
            type: 'text',
        },
        {
            field: 'phoneNumber1',
            label: 'Telefon Numarası - 1',
            type: 'text',
        },
        {
            field: 'phoneNumber2',
            label: 'Telefon Numarası - 2',
            type: 'text',
        },
        {
            field: 'isBusinessCustomer',
            label: 'Ticari Müşteri mi ?',
            type: 'dropdown',
            options: YesNoEnum,
            optionLabel: 'value',
            optionValue: 'id',
            placeholder: 'Ticari Müşteri mi ?',
        },
        {
            field: 'status',
            label: 'Durum',
            type: 'dropdown',
            options: StatusEnum,
            optionLabel: 'value',
            optionValue: 'id',
            placeholder: 'Durum Seçiniz',
        },
        {
            field: 'vkn',
            label: 'VKN',
            type: 'text',
        },
        {
            field: 'companyName',
            label: 'Firma Adı',
            type: 'text',
        },
    ];

    const refreshData = () => {
        window.location.reload();
    };

    const onLoadData = async (lazyParams, filters) => {
        if (!filters?.status) {
            filters.status = 'Aktif'
        }
        setLoading(true);
        const { first, rows, sortOrder } = lazyParams;
        const pageNumber = first / rows;
        const pageSize = rows;

        const requestBody = {
            filter: prepareFiltersForBackend(filters),
            pageNumber: pageNumber,
            pageSize: pageSize,
            sortOrder: sortOrder === 1 ? 'ASC' : sortOrder === -1 ? 'DESC' : null,
        };

        try {
            const response = await axiosInstance.post('/api/v1/customers/paged', requestBody);
            if (response?.status === 200) {
                setData(response.data.content || []);
                setTotalRecords(response.data.totalElements || 0);
                setTableLoading(false);
                // if (response?.data?.content?.length === 0) {
                //     toast.current.show({
                //         severity: "warning",
                //         summary: "Dikkat !",
                //         detail: `Aktif müşteri kaydı mevcut değildir. Müşteri ekleyiniz.`,
                //         life: 3000,
                //     });
                // }
            }

        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Hata",
                detail: `Müşteri verisi getirilirken bir hata oluştu. ${error}`,
                life: 3000,
            });
            console.error('Veriler yüklenirken hata oluştu:', error);
            setTableLoading(false);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1 * 1000);
        }
    };

    const prepareFiltersForBackend = (filters) => {
        const preparedFilters = {};

        for (const key in filters) {
            const filterValue = filters[key];
            if (filterValue) {
                if (Array.isArray(filterValue) && filterValue.length === 2) {
                    preparedFilters[key] = {
                        from: filterValue[0],
                        to: filterValue[1],
                    };
                } else if (typeof filterValue === 'object' && filterValue.id !== undefined) {
                    preparedFilters[key] = filterValue.id;
                } else {
                    preparedFilters[key] = filterValue;
                }
            }
        }
        return preparedFilters;
    };

    return (
        <div className="w-full">
            <Toast ref={toast} />
            <DynamicDataTable
                header="Müşteri Listesi"
                columns={columns}
                filterFields={filterFields}
                data={data}
                totalRecords={totalRecords}
                loading={tableLoading}
                onLoadData={onLoadData}
            />
        </div>
    );
}

export default CustomerList;